module.exports = __webpack_public_path__ + "static/media/camera2.78cd2de7.png";